import { useNavigate } from "react-router-dom";
import { apiCall } from '../api';

const Dashboard = ({ userData }) => {
    const navigate = useNavigate();

    const logOut = async (e) => {
        e.preventDefault();

        await apiCall('DELETE', '/logout');
        return navigate('/');
    }
    return (
        <div className="dashboard__main">
            <div className="dashboard__container">
                <h1>Hi {userData.user.email.charAt(0).toUpperCase() + userData.user.email.slice(1).split("@")[0]}!</h1>
                <button
                    type="submit"
                    className="submit__btn"
                    onClick={(e) => navigate('/quizzes')}>My Quizzes</button>
                <button
                    type="submit"
                    className="submit__btn"
                    onClick={(e) => navigate('/create_quiz')}>Create Quiz</button>
                <button
                    type="submit"
                    className="logout__btn"
                    onClick={(e) => logOut(e)}>Logout</button>
            </div>
        </div>
    )
}

export default Dashboard;
